import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[fileDragDrop]'
})
export class FileDragNDropDirective
{
    @Output() public filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();
    @HostBinding('class.file-drag-over') public isDragOver = false;

    @HostListener('dragover', ['$event'])
    public onDragOver(evt): void
    {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = true;
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(evt): void
    {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = false;
    }

    @HostListener('drop', ['$event'])
    public onDrop(evt): void
    {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = false;
        this.filesChangeEmiter.emit(Array.from(evt.dataTransfer.files));
    }
}
